// extracted by mini-css-extract-plugin
export var container = "_aa-0";
export var containerTopRight = "_aa-1";